export { StoreModel } from "./clients/StoreModel";

export { FDC3 } from "./typedefs";

// @deprecated, use StandardError
export type CallbackError = {
	// Human readable sentence.
	message: string;
	// shot_snake_case_message
	code: string;
};

export type StandardError = Error | string | null | undefined;

// If you need to pass null then use StandardErrorCallback<YourType | null>
export type StandardErrorCallback<R = any> = (err: StandardError, response?: R) => void;

// If you need to pass null then use StandardPromise<YourType | null>
export type StandardPromise<R = any> = Promise<{
	err?: StandardError;
	data?: R;
}>;

export type StandardResponse<R = any> = {
	err?: StandardError;
	data?: R;
};

// @deprecated, use StandardErrorCallback unless you absolutely need to override the error type
export type StandardCallback<E = StandardError, R = any> = (err: E, response?: R) => void;

// Manifest type for FEA
export type Manifest = Record<string, any>;

export type FinsembleConfig = Record<string, any>;

export type AppConfig = Record<string, any>;

export { AppDefinition, SelectConnectAppList } from "./services/Interop/types";
